function merge(e, r) {
  if (!e.length) return void 0;
  const n = [];

  e.forEach((e) => {
    const t = n.findIndex((n) => n[r] == e[r]);

    if (t > -1) {
      const i = [...(n[t].children || []), ...(e.children || [])];

      n[t] = Object.assign(e, n[t], n[t].metadata && { metadata: { ...n[t].metadata, ...e.metadata } });
      if (i.length) {
        n[t].children = merge(i, r);
      }
    } else {
      n.push(Object.assign(e, Array.isArray(e.children) && { children: merge(e.children, r) }));
    }
  });
  return n;
}
export default merge;